export default __webpack_public_path__ + "static/media/tagTick.f7ac876f.svg";